module.exports = __webpack_public_path__ + "media/images/athletes/2020-8ca4c837ecfdaff618bc29ccc97762b6.png";